import React, { useRef, useState } from 'react'
import Label from '../../../components/forms/ui/label/Label'
import Input from '../../../components/forms/ui/inputs/input/Input'
import { TextInputType } from '../../../components/forms/libs/data/formControlTypes'
import FinalMolGrid from '../../../components/FinalMolGrid/FinalMolGrid'
import { useEffect } from 'react'
import { useGetOutstandingInvoicesListMutation } from '../../../app/services/PaymentReconciliation/PaymentReconciliationApi'
import { paginationObj } from '../../../utils/Constants'
import { OutStandingInvoiceListConfig } from '../data/PaymentReconciliationRecordList.Data'
import CenterModel from '../../../components/ui/centerModel/CenterModel'
import AddPaymentProofModel from './AddPaymentProofModel'

const AddRecordsModel = () => {

    const invoiceListRef = useRef();
    const [addProofModelOpen, setAddProofModelOpen] = useState();
    const [selectedInvoice, setSelectedInvoice] = useState();
    const [pagination, setPagination] = useState({
        ...paginationObj,
        searchText: null,
    })

    const [getOutStandingInvoiceList, {
        isLoading: invoiceListLoading,
        isSuccess: invoiceListSuccess,
        data: invoiceListData }] = useGetOutstandingInvoicesListMutation();

    useEffect(() => {
        if (!invoiceListLoading && invoiceListSuccess && invoiceListData) {
            console.log({ invoiceListData })
            setPagination({ ...pagination, totalCount: invoiceListData?.totalCount })
        }
    }, [invoiceListLoading, invoiceListSuccess, invoiceListData]);

    useEffect(() => {
        getOutStandingInvoiceList(pagination);
    }, [])

    const hanldleSearch = (value) => {
        setPagination({ ...pagination, searchText: value });
        getOutStandingInvoiceList({ ...pagination, searchText: value });
    }

    const handlePageChange = (page) => {
        const { pageNumber, pageSize } = page;
        getOutStandingInvoiceList({ ...pagination, pageSize: pageSize, pageNo: pageNumber });
    };

    const handleEditClick = (data) => {
        setSelectedInvoice(data);
        setAddProofModelOpen(true);
    }
    const actionHandler = {
        EDIT: handleEditClick,
    };

    const openModelAddProof = () => {
        setAddProofModelOpen(!addProofModelOpen);
    };

    return (
        <div>
            <div className='d-flex flex-row justify-content-between'>
                <div className=''>
                    {/* <Label labelName={"Search"} htmlFor={'searchOutstandingInvoice'} isRequired={false} /> */}
                    <Input
                        id='searchOutstandingInvoice'
                        type={TextInputType.TEXT}
                        name="searchOutstandingInvoice"
                        placeholder='Invoice No'
                        onChange={hanldleSearch}
                        cssClass="input-field"
                        allowSpace={false}
                    />
                </div>
                <h5 className="align-self-end mb-0">Total Count: {invoiceListData?.totalCount || 0}</h5>
            </div>
            <div className="table-100  mt-2">
                <FinalMolGrid
                    ref={invoiceListRef}
                    configuration={OutStandingInvoiceListConfig}
                    dataSource={invoiceListData?.itemList}
                    isLoading={invoiceListLoading}
                    allowPagination={true}
                    pagination={pagination}
                    onActionChange={actionHandler}
                    onPageChange={handlePageChange}
                />
            </div>
            {addProofModelOpen && <CenterModel
                modelTitle={'Outstanding Invoice Details'}
                show={"test"}
                handleClose={openModelAddProof}
                onUpload={openModelAddProof}
                className='outstanding-invoice-details'
                higherCenterModalClass="higher-centermodal-class"
            >
                <AddPaymentProofModel
                    selectedInvoice={selectedInvoice}
                    openModelAddProof={openModelAddProof}
                />

            </CenterModel>
            }
        </div>
    )
}

export default AddRecordsModel
